import React from 'react'
import { useTranslation } from 'react-i18next'
import { Separator, LayoutBand, Image, H2, Subheading, Paragraph, Bleed } from '@fs/zion-ui'
import { cdnRoot } from '../../services/services'

export default function TempleRecommendQuestions() {
  const [t] = useTranslation()

  return (
    <main>
      <LayoutBand maxWidth="xs">
        <Separator />
        <Bleed sides>
          <Image
            alt={t('templeRecommendQuestions.temple-recommend', 'A family approaching the entrance of a temple')}
            src={`${cdnRoot}/connect/informational/temple_recommend.png`}
          />
        </Bleed>
        <Separator />
        <section>
          <H2 size="H3">
            {t('informational.temple.recommend.questions.heading', 'Temple Recommend Questions')}
            <Separator size="xs" />
            <Subheading>
              {t(
                'informational.temple.recommend.questions.subheading',
                'The interview questions are made public so members of all ages can better understand the requirements for temple worship and prepare to enter the temple.'
              )}
            </Subheading>
          </H2>
          <Separator />
          <ol>
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question1',
                  'Do you have faith in and a testimony of God, the Eternal Father; His Son, Jesus Christ; and the Holy Ghost?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question2',
                  'Do you have a testimony of the Atonement of Jesus Christ and of His role as your Savior and Redeemer?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question3',
                  'Do you have a testimony of the Restoration of the gospel of Jesus Christ?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question4',
                  'Do you sustain the president of The Church of Jesus Christ of Latter-day Saints as the prophet, seer, and revelator and as the only person on the earth authorized to exercise all priesthood keys? Do you sustain the members of the First Presidency and the Quorum of the Twelve Apostles as prophets, seers, and revelators? Do you sustain the other General Authorities and local leaders of the Church?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question5',
                  'The Lord has said that all things are to be “done in cleanliness” before Him (Doctrine and Covenants 42:41). Do you strive for moral cleanliness in your thoughts and behavior? Do you obey the law of chastity?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question6',
                  'Do you follow the teachings of the Church of Jesus Christ in your private and public behavior with members of your family and others?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question7',
                  'Do you support or promote any teachings, practices, or doctrine contrary to those of The Church of Jesus Christ of Latter-day Saints?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question8',
                  'Do you strive to keep the Sabbath day holy, both at home and at church; attend your meetings; prepare for and worthily partake of the sacrament; and live your life in harmony with the laws and commandments of the gospel?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t('informational.recommend.questions.question9', 'Do you strive to be honest in all that you do?')}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t('informational.recommend.questions.question10', 'Are you a full-tithe payer?')}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t('informational.recommend.questions.question11', 'Do you understand and obey the Word of Wisdom?')}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question12',
                  'Do you have any financial or other obligations to a former spouse or to children? If yes, are you current in meeting those obligations?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question13',
                  'Do you keep the covenants that you made in the temple?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question14',
                  'Do you honor your sacred privilege to wear the garment as instructed in the initiatory ordinances?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question15',
                  'Are there serious sins in your life that need to be resolved with priesthood authorities as part of your repentance?'
                )}
              </Paragraph>
            </li>
            <Separator />
            <li>
              <Paragraph size="sm" dense>
                {t(
                  'informational.recommend.questions.question16',
                  "Do you consider yourself worthy to enter the Lord's house and participate in temple ordinances?"
                )}
              </Paragraph>
            </li>
            <Separator />
          </ol>
        </section>
        <Separator />
      </LayoutBand>
    </main>
  )
}
